module.exports = __webpack_public_path__ + "img/icon-spark.fca6e156.svg";